import { FILTER_CONTROL_HEIGHT_CLASS, Tabs } from "@components";
import { cx } from "@/utils/cx";
import { EXPENSE_STATUS_FILTER_OPTIONS } from "../constants";
import type { ExpenseStatus } from "../types";

type ExpenseCostFiltersProps = {
	value: ExpenseStatus | 0;
	onChange: (value: ExpenseStatus | 0) => void;
};

export function ExpenseCostFilters({
	value,
	onChange,
}: ExpenseCostFiltersProps) {
	return (
		<fieldset
			aria-label="Filtros de custo por veículo"
			className="m-0 min-w-0 max-w-full overflow-x-auto border-0 p-0"
		>
			<Tabs
				className="items-start"
				onSelectionChange={(tabId) =>
					onChange(Number(tabId) as ExpenseStatus | 0)
				}
				selectedKey={value}
			>
				<Tabs.List
					aria-label="Situação do custo por veículo"
					className={cx(
						"w-fit rounded-lg p-[3px]",
						FILTER_CONTROL_HEIGHT_CLASS
					)}
					items={EXPENSE_STATUS_FILTER_OPTIONS}
					size="sm"
					type="button-border"
				>
					{(tab) => (
						<Tabs.Item
							{...tab}
							className="h-full text-xs aria-selected:bg-brand-solid aria-selected:text-white"
						/>
					)}
				</Tabs.List>
			</Tabs>
		</fieldset>
	);
}
